import { Button } from "@mui/material";
import React, { useContext, useState } from "react";
import { createOrUpdateAlenSchedule } from "src/services/alen/useAlenSchedules";
import { AuthContext } from "src/contexts/AuthContext";
import ScheduleTargetSelectionDialog from "./SchduleTargetSelectionDialog";
import NewScheduleDetailsDialog from "./NewSchedulingDetailsDialog";
import {
  getDefaultNewScheduling,
  useAlenSchedulingContext,
} from "./AlenSchedulingContext";
import { ScheduleDto, ScheduleTargetSelection } from "./types";

function AddAlenScheduleButton({ onCreated }: { onCreated: () => void }) {
  const [targetSelectionDialogOpen, setTargetSelectionDialogOpen] =
    useState(false);
  const [scheduleDetailDialogOpen, setScheduleDetailDialogOpen] =
    useState(false);
  const { setScheduleTarget, setNewScheduling, alenPropertyId } =
    useAlenSchedulingContext();
  const { user } = useContext(AuthContext);
  const handleNext = async (target: ScheduleTargetSelection) => {
    setScheduleTarget(target);
    setTargetSelectionDialogOpen(false);
    setScheduleDetailDialogOpen(true);
  };

  const handleBack = () => {
    setTargetSelectionDialogOpen(true);
    setScheduleDetailDialogOpen(false);
  };

  const handleSave = async (schedule: ScheduleDto) => {
    setTargetSelectionDialogOpen(false);
    if (!user?.alen) {
      return;
    }
    await createOrUpdateAlenSchedule(user.alen, schedule);
    onCreated();
    setScheduleDetailDialogOpen(false);
  };

  const handleCreateSchedule = () => {
    setNewScheduling(getDefaultNewScheduling(alenPropertyId));
    setTargetSelectionDialogOpen(true);
  };

  return (
    <>
      <Button variant="outlined" color="info" onClick={handleCreateSchedule}>
        Add Schedule
      </Button>
      <ScheduleTargetSelectionDialog
        open={targetSelectionDialogOpen}
        onClose={() => setTargetSelectionDialogOpen(false)}
        onNext={handleNext}
      />
      <NewScheduleDetailsDialog
        onClose={() => setScheduleDetailDialogOpen(false)}
        open={scheduleDetailDialogOpen}
        onBack={handleBack}
        onSave={handleSave}
      />
    </>
  );
}

export default AddAlenScheduleButton;
